import { Directive, HostListener } from '@angular/core';
import { BroadcastService } from '../shared/services/broadcast.service';

/**
 * @description
 *  The event published is "event:keydown:[keycode]" where keycode is the
 *  event keycode:
 *
 *     13 = enter,
 *     37 = left arrow key,
 *     39 = right arrow key,
 *     45 = insert
 *     27 = escape
 *     ...
 *
 */

@Directive({
  selector: '[appGlobalBinds]',
})
export class GlobalBindsDirective {
  @HostListener('window:resize', ['$event'])
  public onResize(e): void {
    this.broadcastService.broadcast('event:window.resize', e);
  }

  @HostListener('document:keydown', ['$event']) public onKeydownHandler(e: KeyboardEvent): void {
    this.broadcastService.broadcast('event:keydown:' + e.which, e);
  }

  constructor(private broadcastService: BroadcastService) {}
}
